
import { useEffect, useState } from 'react'
import { BriefcaseBusiness, Plus, XIcon } from 'lucide-react'
import Style from './style.module.css'
import LeftSidePopupLayout from '../../../../component/popup/modal-layout'
import AddVendorPopup from '../vendor/add-popup'
import AddPopup from '../list/add-popup'
import AddInvoicePopup from '../invoice/add-popup'
import { useApiCall } from '../../../../component/custom-hooks/api-call'
import UpdateInvoicePopup from '../invoice/update'

const UpdateInvoice = ({ onClose = () => { }, onError = () => { }, onSubmit = () => { }, invoiceId }) => {

    const [allRecords, setAllRecords] = useState([])

    const apiCall = useApiCall();

    const getAllRecords = async() => {
        try {
            let apiRes = await apiCall({method: "get", url: "get-water-tanker-entry-list?status=pending"});
            // console.log("apiRes", apiRes)
            setAllRecords(apiRes?.data)
        } catch (error) {
            console.log("Error", error)
        }
    }

    useEffect(() => {
        getAllRecords()
    } , [])

    return (
        <>
            <div className={Style.modal_body}>
                <LeftSidePopupLayout popupStatus={true} className={`${Style.departmentChangeModal}`}>

                    <UpdateInvoicePopup
                        onClose={onClose}
                        onError={onError}
                        onSubmit={onSubmit}
                        Style={Style}
                        records={allRecords}
                        invoiceId={invoiceId}
                    />
                </LeftSidePopupLayout>
            </div>
        </>
    )
}

export default UpdateInvoice
